export default __webpack_public_path__ + "static/media/TomaAsistencia.1f4667bd.svg";